<template>
  <div :class="containerClass" v-if="pageBlank">
    <router-view />
    <div class="loading p-component-overlay" v-if="$store.getters.isLoading">
      <div class="loading-body">
        <ProgressSpinner v-if="$store.getters.dataLoading.icon != undefined && $store.getters.dataLoading.icon != null" strokeWidth="4" fill="#FFFFFF"/>
        <span v-if="$store.getters.dataLoading.content != undefined && $store.getters.dataLoading.content != null && $store.getters.dataLoading.content != ''"> {{ $store.getters.dataLoading.content }}</span>
      </div>
    </div>
  </div>
  <div :class="containerClass" v-else>
    <AppTopBar :menuClick="isSidebarVisible()" @menu-toggle="onMenuToggle" />
    <transition name="layout-sidebar" > 
      <div :class="sidebarClass"  v-show="isSidebarVisible()">
        <div class="layout-logo">
          <router-link to="/">
            <img width="150px" alt="Hồng ký" :src="logo" />
          </router-link>
        </div>
        <AppMenu :key="componentMenu" :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>
    <div class="admin-layout layout-main">
      <router-view />
    </div>
    <AppFooter />
    <Toast />
    <div class="loading p-component-overlay" v-if="$store.getters.isLoading">
      <div class="loading-body">
        <ProgressSpinner v-if="$store.getters.dataLoading.icon != undefined && $store.getters.dataLoading.icon != null" strokeWidth="4" fill="#FFFFFF"/>
        <span v-if="$store.getters.dataLoading.content != undefined && $store.getters.dataLoading.content != null && $store.getters.dataLoading.content != ''"> {{ $store.getters.dataLoading.content }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import DataServices from '@/core/DataServices'
import AppTopBar from './layout/Topbar';
import AppMenu from './layout/Menu';
import AppFooter from './layout/Footer';
// import moment from 'moment'
export default {
  name: 'AdminLayout',
  components: {
    'AppTopBar': AppTopBar,
    'AppMenu': AppMenu,
    'AppFooter': AppFooter
  },
  computed: {
    pageBlank() {
      if (this.$route.name == 'serial_number_print') return true;
      return false;
    },
    containerClass() {
      return ['layout-wrapper', {
        'layout-overlay': this.layoutMode === 'overlay',
        'layout-static': this.layoutMode === 'static',
        'layout-static-sidebar-inactive': this.staticMenuInactive  && this.layoutMode === 'static',
        'layout-overlay-sidebar-active': this.overlayMenuActive  && this.layoutMode === 'overlay',
        'layout-mobile-sidebar-active': this.mobileMenuActive
      }];
    },
    sidebarClass() {
      return ['layout-sidebar', {
        'layout-sidebar-dark': this.layoutColorMode === 'dark',
        'layout-sidebar-light': this.layoutColorMode === 'light'
      }];
    },
    logo() {
      return (this.layoutColorMode === 'dark') ? "../../../assets/images/logo_HK-01.png" : "../../../assets/images/logo_HK-01.png";
    },
    isLoading() {
      return this.$store.isLoading
    },
    dataLoading() {
      return this.$store.dataLoading
    }
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden');
    else
      this.removeClass(document.body, 'body-overflow-hidden');
  },
  watch: {
    $route() {
      this.menuActive = false;
    }
  },
  async mounted () {
    if(!this.pageBlank) document.body.style.zoom = "75%";
    if (this.$store.getters.fullname.user_type == 2) {
      await this.permissionData();
    }
  },
  methods: {
    async permissionData() {
      var variables = {
        where_key: {
          role_id: {'_eq': this.$store.getters.role.role_id},
          status: {'_eq': 1},
          permission: {
            status: {_eq: 1},
            type: {_eq: "web"}
          }
        }
      }
      var data = await DataServices.getList('role_permission', {"variables": JSON.stringify(variables), "fields": "id role_id  permission_id permission { config } "});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        var permission = list.map(function(a) {
          if (a.permission.config != undefined && a.permission.config != null) return a.permission.config;
        });
        localStorage.setItem('Permission', JSON.stringify(permission));
        this.$store.commit('setPermission', permission);
        this.componentMenu = Math.random()*1000;
      }
    },
    onMenuToggle() {
      this.menuClick = true;
      if (this.layoutMode === 'overlay') {
        this.overlayMenuActive = !this.overlayMenuActive;
        localStorage.setItem('sidebarOpen', this.overlayMenuActive);
      }
      else if (this.layoutMode === 'static') {
        this.staticMenuInactive = !this.staticMenuInactive;
        localStorage.setItem('sidebarOpen', this.staticMenuInactive);
      }
      event.preventDefault();
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
        if(this.$route.path !== event.item.to) {
          var info = this.$router.resolve(event.item.to)
          this.$router.push({name: info.route.name, params: {reload: true}})
        }
      }
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      let sidebarOpen = localStorage.getItem('sidebarOpen');
      if (this.isDesktop()) {
        if (this.layoutMode === 'static') {
          if (!this.menuClick && sidebarOpen != undefined && sidebarOpen != null) {
            this.staticMenuInactive = ( sidebarOpen === 'true' );
          } 
          return !this.staticMenuInactive;
        } else if (this.layoutMode === 'overlay') {
          if (!this.menuClick && sidebarOpen != undefined && sidebarOpen != null) {
            this.overlayMenuActive = ( sidebarOpen === 'true' );
          }
          return this.overlayMenuActive;
        }
      }
      return true;
    }
  },
  data() {
    return {
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menuClick: false,
      componentMenu: Math.random()*100,
      menu: [
        // {
        //   label: 'Quản lý model sản phẩm',  to: '/admin/product', id: 'product'
        // },
        {
          label: 'Báo cáo',
          items:[
            {
              label: 'Báo cáo',  to: '/admin/report', id: 'report'
            },
            { 
              label: 'Lịch sử xuất dữ liệu',  to: '/admin/history-export', id: 'history_export'
            },
          ]
        },
        {
          label: 'Sản xuất',
          // id: 'serial_number',
          // root: true,
          items:[
            {
              label: 'Quản lý model sản phẩm',  to: '/admin/product', id: 'product'
            },
            { 
              label: 'Tạo và in serial number',  to: '/admin/serial-number/add', id: 'serial_number_add'
            },
            {
              label: 'Quản lý serial number',  to: '/admin/serial-number', id: 'serial_number'
            }
          ]
        },
        
        {
          label: 'Khách hàng',
          items:[
            { 
              label: 'Quản lý khách hàng',  to: '/admin/customer', id: 'customer'
            },
          ]
        },
        {
          label: 'Kích hoạt',
          items:[
            {
              label: 'Quản lý kích hoạt bảo hành',  to: '/admin/warranty-activation', id: 'warranty_activation'
            },
            {
              label: 'Thẩm định sản phẩm',  to: '/admin/appraisal-product', id: 'appraisal_product'
            },
            {
              label: 'Quản lý báo cáo sự cố',  to: '/admin/report-violation', id: 'report_violation'
            }
          ]
        },
        {
          label: 'Bảo hành',
          items:[
            {
              label: 'Sửa chữa - bảo hành - bảo trì',  to: '/admin/warranty-repair', id: 'warranty_repair'
            },
            {
              label: 'Kế hoạch bảo trì định kỳ',  to: '/admin/maintenance', id: 'maintenance'
            },
            {
              label: 'Quản lý gói dịch vụ',  to: '/admin/service-park', id: 'service_park'
            },
            {
              label: 'Quản lý vật tư - dịch vụ',  to: '/admin/service-supplies', id: 'service_supplies'
            },
          ]
        },
        {
          label: 'Cơ cấu tổ chức',
          items:[
            {
              label: 'Quản lý đơn vị',  to: '/admin/organization', id: 'organization'
            },
            {
              label: 'Quản lý cấp bậc',  to: '/admin/user-level', id: 'user_level'
            }
          ]
        },
        {
          label: 'Phân quyền',
          items:[
            {
              label: 'Quản lý phân quyền',  to: '/admin/role', id: 'role'
            },
            {
              label: 'Quản lý người dùng',  to: '/admin/users', id: 'users'
            }
          ]
        },
        {
          label: 'Cấu hình',
          items:[
            {
              label: 'Cấu hình hệ thống',  to: '/admin/config', id: 'config'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
body{ font-size: 14px; font-weight: 400;}
.admin-layout{ font-size: 1rem;
  .card-w-title{padding: 1em 1.5em; border-radius: 5px; border: 1px solid #ccc;
    .manager-title { color: #1D3118; font-size: 25px;}
    .box-title{font-size: 20px;}
  }
}
button{outline: none !important;}
.import-data{ padding: 15px 0;
  .download-file{margin-top: 10px;
    span{color: #000; display: inline-block; margin-right: 15px; font-size: 16px;}
    a{color: #169bd5; font-weight: bold; cursor: pointer; display: inline-block; font-size: 16px;
      &:hover{color: #169bd5;}
      i{padding-left: 5px; color: #169bd5; font-weight: bold;}
    }
    // color: #fff;  border-width: 0px;  border: none; border-radius: 5px; padding: 5px 20px;
    
  }
  .box-form-import{ margin-bottom: 15px; display: flex;
    .item-inline-import{
      &.middle-inline{padding: 0 25px 0 15px; position: relative; top: -3px;
        &.normal{top: 5px;}
        a{cursor: pointer; display: block; color: #169bd5; font-weight: bold; font-size: 16px;}
      }
      &.disabled{background-color: rgba(153, 153, 153, 1); color: #fff; border: 1px solid rgba(153, 153, 153, 1); opacity: 1;}
      label{color: #000; font-size: 14px; margin: 0;
        &.normal{color: #999999;}
      }
    }
    button{background: rgba(22, 155, 213, 1); width: 99px; height: 35px; border-radius: 5px; border: 0 none;
      &.background-none{background-color: rgba(153, 153, 153, 1); color: #fff; border: 1px solid rgba(153, 153, 153, 1);} 
      span{position: relative; top: 0px;}
    }
  }
}
.p-calendar {
  .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;
    .p-datepicker-header{padding: 5px !important;}
    td { padding: 0px !important;
      a {padding: 0px !important;}
      span {padding: 0px !important; width: 30px !important; height: 30px !important;}
    }
  }
}

.p-field-checkbox{ 
  label{margin-bottom: 0; margin-left: 1rem;}
}
.dialog-delete{ min-width: 300px; border: 0;border-radius: 5px; overflow: hidden;}
.error, .p-invalid{color: #f00;}
.p-invalid{display: block;}
.p-field {
  .p-invalid {font-size: 14px; font-style: italic;}
}
.txt-center{text-align: center !important;}
.txt-right{text-align: right !important;}
.txt-left{text-align: left !important;}
.txt-error {color: #f00 !important;}
.black-color{color: #000 !important;}
.bold{font-weight: bold;}
.disabled-opacity{opacity: 1 !important;
  .p-disabled{opacity: 1 !important;}
}
.display-none{display: none;}
.padding-content{
  .pi-external-link{padding-left: 5px;}
}
.loading{z-index: 2000;
  .loading-body{background: #ffff; z-index: 4000; margin: 0 auto; width: 300px; border-radius: 5px; padding: 10px; position: relative; top: 45%; display: flex; align-items: center;
    .p-progress-spinner{width: 50px; height: 50px; margin: 0; margin-right: 10px;}
    span{font-size: 18px;}
  }
}
.external-link span {font-weight: bold;}
.active-route{ color: #0388e5 !important;}
.align-items{display: flex; align-items: center;}
// .disabled-select{
//   .p-disabled{opacity: 1 !important;}
//   .p-dropdown{width: 100%; border: 0; background: transparent; border-radius: 0; cursor: not-allowed;
//     .p-dropdown-label{background: transparent;}
//     .p-dropdown-trigger{background: transparent; }
//   }
// }
.list-title{background: #f8f9fa; color: #495057; border: 1px solid #e9ecef; border-width: 1px 0 1px 0; padding: 1rem;font-size: 20px; align-items: center; display: flex; justify-content: space-between;
  .p-m-0 {margin: 0!important;}
}
.p-dialog {
  .p-dialog-header{background: #fff; 
    span{font-size: 25px !important; font-weight: normal !important;}
  }
}
.log-changed{
  .p-datatable {
    .p-datatable-thead{
      tr {
        th {background: #169BD5;
          .p-column-title{color: #fff;}
        }
      }
    }
    .p-datatable-tbody{
      tr {
        &.p-datatable-row-expansion{ 
          td {
            padding: 0; padding-left: 20px;
          }
        }
        td{
          .p-row-toggler{outline: auto; box-shadow: none;
            .p-row-toggler-icon{color: #fff; font-weight: bold; background: #ccc; width: 25px; height: 25px;  border-radius: 50%; display: block; align-items: center; text-align: center; padding-top: 5px;
              &.pi-chevron-down{background: #51BDE3;}
            }
          }
        }
      }
    }
  }
}
.table-subtable{
  .p-datatable {
    .p-datatable-thead{
      tr {
        th {background: #339966;
          .p-column-title{color: #fff; display: block !important;}
        }
      }
    }
    .p-datatable-tbody{
      tr {
        &:last-child{
          td{border-bottom: none;}
        }
        td{padding: 0.571rem 0.857rem !important;}
      }
    }
  }
}
.popup-dialog{border: 0 none;
  .p-dialog-content{padding: 10px 50px;
    .form-popup-custom{
      .input-number-inline{display: inline-block; margin-left: 10px;
        .p-inputnumber-buttons-stacked{display: flex;}
        .p-inputnumber-input{width: 54px; }
        .p-inputnumber-button-group{
          .p-button.p-button-icon-only{padding: 0;}
        }
      }
    }
  }
  .p-dialog-footer{padding-left: 50px; padding-right: 50px;
    button{ border-radius: 5px; padding: 10px 40px;
        &:last-child{margin: 0;}
    }
  }
}
.popup-confirm {
  .p-dialog-footer{text-align: center; border: 0 none;
    button{width: 120px; margin-right: 50px; border-radius: 5px;
        &:last-child{margin: 0;}
    }
  }
}
.p-dialog {
    &.dialog-header-custom{
      .p-dialog-header-icons{
          &:last-child{display: none;}
      }
    }
}
.p-column-filter{max-width: 100%;}
.box-tabview {
  .p-tabview-panels { padding: 20px !important; }
}
.p-datatable {
  .p-datatable-thead {
    tr {
      th {border: 1px solid #e9ecef; border-width: 0 0 1px 0;font-weight: 600;color: #495057;background: #f8f9fa; transition: box-shadow 0.2s;
        &.p-filter-column{
          input, select{padding: 0.5rem 0.5rem !important};
        }
        .p-checkbox-box{width: 20px; height: 20px;}
      }
      .p-sortable-column:not(.p-highlight):hover{background:#f8f9fa;}
    }
  }
 .p-datatable-tbody {
   tr {
      td {border: 1px solid #e9ecef; border-width: 0 0 1px 0;    font-size: 1rem; font-weight: normal;
        .p-button-edit{border-radius: 50%; height: 2.357rem; width: 2.357rem; padding: 0.5rem 0;}
        .p-button-danger{border-radius: 50%; height: 2.357rem; width: 2.357rem; padding: 0.5rem 0;}
        .p-checkbox-box{width: 20px; height: 20px;}
      }
      &:nth-child(even) { background: #fff;}
      &.p-highlight{background: transparent; color: #333;}
      &:nth-child(even).p-highlight{background: transparent;color: #333;}
    }
    tr:not(.p-highlight):hover{background: #fff !important;}
    
  }
}
.p-paginator{background: #ffffff; color: #6c757d; border:0 none; border-bottom:1px solid #e9ecef !important;  padding: 0.5rem 1rem; border-radius: 3px;
  .p-datatable .p-paginator-bottom {
    border-width: 0 0 1px 0;
    border-radius: 0;
  }
  .pi-step-backward:before {
    content: "\e92d";
  }
  .pi-caret-left:before{
    content: "\e931";
  }
  .pi-caret-right:before{
    content: "\e932";
  }
  .pi-step-forward:before {
    content: "\e92e";
  }
  .p-paginator-pages {
    .p-paginator-page {
      &.p-highlight { background: #E3F2FD; border-color: #E3F2FD; color: #495057; }
    }
    .p-paginator-page:not(.p-highlight):hover {  background: #e9ecef; border-color: transparent;color: #495057;}
    .p-paginator-page {background-color: transparent; border: 0 none; color: #6c757d; min-width: 2.357rem; height: 2.357rem; margin: 0.143rem;transition: box-shadow 0.2s; border-radius: 3px;}
  }
  .p-paginator-first {margin-left: auto;}
  .p-paginator-current {margin-left: auto; margin-right: 10px;}
}
.label-header-action{display: block !important;}
.p-inputswitch {
  &.p-inputswitch-checked{
    .p-inputswitch-slider {
      &:before{background: #fff !important;}
    }
  }
}
.custom-qr-code{ width: 400px !important; height: 210px !important; padding: 10px !important;
  .header-serial-number{padding: 0 0 5px 0 !important;
    .item {
      &.title{/*font-size: 14pt !important;*/font-size: 12pt !important;}
      &.txt-right{/*font-size: 14pt !important;*/font-size: 12pt !important;}
    }
  }
  .bottom-serial-number{ padding: 5px 0 !important;
    .body-info{width: 55% !important;
      .item-info{font-size: 12pt !important; padding-bottom: 5px;
        &.border-custom{ padding: 5px 0;
          img{width: auto;}
          span {font-size: 14pt !important;}
        }
        &:last-child{font-size: 14pt !important;}
      }
      &.body-qr{width: 45% !important; height: auto !important;  float: right !important; padding-top:2px !important;margin: 0 !important;
        .qr-custom{width: 150px; height: 150px;  margin-left: auto;}
      }
    }
  }
}
.cool-lightbox {
  .cool-lightbox__slide {
    img { margin: auto !important;}
  }
}
.special-day {
    text-decoration: line-through;
}
/* Responsive */
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.layout-footer{background: transparent;}
.p-datatable-wrapper{
  table{table-layout: fixed !important;}
}
.layout-sidebar-dark{background: #4d505b;}
.layout-menu {
  li {
    a{font-size: 15px; border: 0 none !important; padding: 0.7em 1em;
      &:hover, &.active-route{ background: #333; color: #199ED8;}
    }
    &.group-class{
      a{text-transform: uppercase; color: #199ED8; 
        &:hover {background: #4d505b; }
      }
    }
  }
}
@media screen and (min-width: 767px) {
  .date-custom { min-width: 220px !important;
    .p-inputtext {width: 100% !important;}
    .p-button.p-button-icon-only{width: 50px;}
  }
}

.import-data-custom .download-file-custom {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data-custom{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}
</style>
